import cn from 'clsx'
import { StyledRow } from './style'

const Row = ({ children, noGutter, className, gutters, ...restProps }) => {
  return (
    <StyledRow
      className={cn(className, noGutter && 'gx-0')}
      $gutters={gutters}
      {...restProps}
    >
      {children}
    </StyledRow>
  )
}

export default Row
